import { render } from "./CustomizedSize.vue?vue&type=template&id=4ce35a77"
import script from "./CustomizedSize.vue?vue&type=script&lang=ts"
export * from "./CustomizedSize.vue?vue&type=script&lang=ts"
script.render = render

export default script